export const SET_EXAMPLE_MODAL = 'SET_EXAMPLE_MODAL';

export const setExampleModal = showModal => {
  return { type: SET_EXAMPLE_MODAL, payload: showModal };
};
